import React from "react";
import Icons from "../icons";

/* True when the query is empty or any value contains it (case-insensitive). */
export function matchesQuery(query, ...values) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return true;
  return values.some((v) => String(v ?? "").toLowerCase().includes(q));
}

/* A small search box that filters a list already loaded on screen (no request). */
export default function ListSearch({ value, onChange, placeholder = "Search…", label = "Search", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Icons.Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={label}
        className="w-full rounded-lg border border-slate-300 bg-card py-1.5 pl-8 pr-8 text-[0.8125rem] text-slate-900 outline-none focus:border-brand-600 focus:ring-2 focus:ring-brand-600/25"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label={`Clear ${label.toLowerCase()}`}
          className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
        >
          <Icons.X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}

/* What a filtered list shows when nothing matches. */
export function NoMatches({ query }) {
  return <p className="px-4 py-6 text-center text-xs text-slate-400">No matches for “{query.trim()}”.</p>;
}
